import React from 'react'
import PropTypes from 'prop-types'

import { AVATAR_SIZE } from '../../constants'

const Avatar = ({ src, width, ...restProps }) => (
  <img
    // I created a cloudflare worker to proxy requests and add the cors header to allow any host so the pdf writer would work
    src={'https://proxy.jellyfish.chat?url='+src}
    className="rounded"
    // className="rounded border"
    width={width}
    height={width}
    alt="avatar"
    // crossorigin=""
    {...restProps}
  />
)

Avatar.defaultProps = {
  width: AVATAR_SIZE,
}

Avatar.propTypes = {
  width: PropTypes.number,
}

export default Avatar



// WEBPACK FOOTER //
// ./src/components/common/Avatar.jsx